export default __webpack_public_path__ + "static/media/50k.277bab12.yaml";